<mcg-loader [showLoader]="showLoader" />
<mcg-grid id="gridMoviles" #movilesContainer #gridMovil [columns]="columns" [data]="dataAdapter" [configuration]="gridConfig"
  (rowClick)="onRowClick($event)" (gridRendered)="onGridRendered($event)" (filter)="onChangeFilter($event)" (sort)="onSort($event)">
</mcg-grid>
